import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_ctx.b('', { view: _ctx.view })),
    disabled: _ctx.notVerified
  }, [
    _renderSlot(_ctx.$slots, "icon-left"),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('label'))
    }, [
      _renderSlot(_ctx.$slots, "label")
    ], 2)
  ], 10, _hoisted_1)), [
    [_directive_tooltip, _ctx.notVerified ? _ctx.$t('Для получения доступа пройдите процедуру верификации') : null]
  ])
}